import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/TermsOfUsePage.css';

const TermsOfUsePage: React.FC = () => {
  return (
    <div className="legal-page-wrapper">
      <div className="legal-page-back">
        <Link to="/home" className="legal-page-back-link">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to home
        </Link>
      </div>
      <main className="legal-page-content">
        <h1 className="legal-page-title">Terms of Use</h1>
        <p className="legal-page-meta">
          <strong>Last updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <p className="legal-page-intro">
          By accessing or using Mends, you agree to be bound by these Terms of Use. Please read them carefully before using our services.
        </p>

        <p className="legal-page-intro">
          By continuing to use our platform, you accept these Terms. If you do not agree, please do not use our services.
        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">1. Acceptance of Terms</h2>
        <p className="legal-page-paragraph">
          By creating an account or using the platform, you accept and agree to comply with these Terms and all applicable laws and regulations. If you do not agree with these Terms, you must not use the platform.
        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">2. Eligibility</h2>
        <p className="legal-page-paragraph">
          You must be at least 18 years of age to use our services. By accepting these Terms, you represent that you have the legal capacity to enter into a binding contract and are not prohibited from using the services under applicable law.
        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">3. Use of the Platform</h2>
        <div className="legal-page-section">
          <ul className="legal-page-list">
            <li>
              <strong>Account Responsibility:</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately of any unauthorized use.
            </li>
            <li>
              <strong>Acceptable Use:</strong> You agree not to use the platform for any illegal or unauthorized purpose, including but not limited to violation of intellectual property rights or transmission of unlawful content.
            </li>
            <li>
              <strong>License:</strong> We grant you a limited, non-exclusive, non-transferable license to access and use the platform in accordance with these Terms.
            </li>
            <li>
              <strong>Third-Party Services:</strong> When you connect third-party services (e.g., Gmail, WhatsApp), you must comply with their respective terms of service and grant us access only as permitted by those services.
            </li>
          </ul>
        </div>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">4. Intellectual Property</h2>
        <p className="legal-page-paragraph">
          All rights, title, and interest in the platform, including its content, are owned by us or our licensors and are protected by intellectual property laws. You may not reproduce, distribute, or create derivative works without our express permission.
        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">5. Fees and Payments</h2>
        <div className="legal-page-section">
          <ul className="legal-page-list">
            <li>
              <strong>Subscriptions:</strong> Some services may require subscription fees. Fee details and plans will be provided at the time of purchase.
            </li>
            <li>
              <strong>Refund Policy:</strong> Paid fees are generally non-refundable except as required by law or as specified in our refund policy.
            </li>
          </ul>
        </div>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">6. Termination</h2>
        <p className="legal-page-paragraph">
          We reserve the right to suspend or terminate your access to the platform at any time, without prior notice, if you violate these Terms or engage in conduct we deem harmful.

        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">7. Disclaimer of Warranties</h2>
        <p className="legal-page-paragraph">
          The platform is provided "as is" and "as available." We do not warrant that the services will be uninterrupted, secure, or error-free. To the maximum extent permitted by law, we disclaim all warranties, express or implied.
        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">8. Limitation of Liability</h2>
        <p className="legal-page-paragraph">
          To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from or related to your use or inability to use the platform, even if we have been advised of the possibility of such damages.
        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">9. Indemnification</h2>
        <p className="legal-page-paragraph">
          You agree to indemnify and hold us harmless from any claims, damages, losses, or expenses (including reasonable attorneys' fees) arising from your violation of these Terms or activities related to your account.
        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">10. Changes to Terms</h2>
        <p className="legal-page-paragraph">
          We may modify these Terms at any time. We will notify you of material changes by posting the updated Terms on this page and updating the "Last updated" date. Your continued use of the platform after such changes constitutes acceptance of the new Terms.
        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">11. Governing Law</h2>
        <p className="legal-page-paragraph">
          These Terms shall be governed by and construed in accordance with applicable laws. Any dispute arising from these Terms shall be resolved in the courts of competent jurisdiction.
        </p>

        <hr className="legal-page-divider" />

        <h2 className="legal-page-h2">12. Contact</h2>
        <p className="legal-page-paragraph">
          For questions or concerns about these Terms of Use, please contact us through the contact information available on our platform.
        </p>

        <div className="legal-page-footer">
          <Link to="/home" className="legal-page-back-link">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Back to home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default TermsOfUsePage;
